import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Panel({ children, padding = 20, style = {}, className = "" }) {
  return (
    <div
      className={`rf-card ${className}`}
      style={{
        background: t.surface,
        border: `1.5px solid ${t.border}`,
        borderRadius: 12,
        padding,
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        transition: "border-color 0.15s, box-shadow 0.15s",
        ...style,
      }}
    >{children}</div>
  );
}

export function StatCard({ label, value, sub, trend, delay = "0s" }) {
  const pos = trend && trend.startsWith("+");
  return (
    <Panel
      className="rf-a1"
      style={{
        flex: 1, minWidth: 160,
        animationDelay: delay,
        position: "relative", overflow: "hidden",
        borderBottom: `3px solid ${pos ? t.emerald : t.border}`,
      }}
    >
      <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.1em", color: t.textMuted, textTransform: "uppercase", marginBottom: 10, fontFamily: font.body }}>{label}</div>
      <div style={{ fontSize: 32, fontWeight: 700, color: t.textPrimary, fontFamily: font.mono, lineHeight: 1, marginBottom: 8 }}>{value}</div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {trend && (
          <span style={{
            fontSize: 11, fontWeight: 700, fontFamily: font.body,
            color: pos ? t.emeraldDeep : t.coral,
            background: pos ? t.emeraldLight : t.coralLight,
            padding: "2px 7px", borderRadius: 4,
          }}>{trend}</span>
        )}
        {sub && <span style={{ fontSize: 11, color: t.textMuted, fontFamily: font.body }}>{sub}</span>}
      </div>
    </Panel>
  );
}

export function Divider({ label }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "16px 0" }}>
      <div style={{ flex: 1, height: 1, background: t.border }} />
      {label && <span style={{ fontSize: 10, color: t.textMuted, fontFamily: font.body, whiteSpace: "nowrap", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 600 }}>{label}</span>}
      <div style={{ flex: 1, height: 1, background: t.border }} />
    </div>
  );
}

export function SectionLabel({ children }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 14 }}>
      <div style={{ width: 3, height: 14, borderRadius: 99, background: t.emerald }} />
      <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.12em", color: t.textMuted, textTransform: "uppercase", fontFamily: font.body }}>{children}</span>
    </div>
  );
}

export function EmptyState({ icon = "○", title, sub }) {
  return (
    <div style={{ textAlign: "center", padding: "44px 20px", fontFamily: font.body }}>
      <div style={{ fontSize: 34, marginBottom: 12, opacity: 0.2 }}>{icon}</div>
      <div style={{ fontSize: 14, color: t.textSecondary, fontWeight: 500 }}>{title}</div>
      {sub && <div style={{ fontSize: 12, color: t.textMuted, marginTop: 5 }}>{sub}</div>}
    </div>
  );
}
